import NavMainV9 from './NavMainV9';
import { useNavHostStyles } from './navMainStylesV9';

interface INavRootOverlayProps {
  onClose: () => void;
}

//
// The full menu, shown over the page while the pointer rests on the compact rail. It does not dim the page
// behind it; it closes when the pointer leaves it, on Escape, and when a page is picked (NavRoot).
//
const NavRootOverlay = (props: INavRootOverlayProps) => {
  const styles = useNavHostStyles();

  return (
    <div
      className={styles.flyout}
      onMouseLeave={() => props.onClose()}
      onKeyDown={(ev) => {
        if (ev.key === 'Escape') props.onClose();
      }}
    >
      <NavMainV9 presentation="full" />
    </div>
  );
};

export default NavRootOverlay;
